var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center"},[_c('v-spacer'),_vm._l((['poli', 'orvea', 'amort']),function(item){return _c('img',{key:item,staticClass:"logo px-5",class:`logo-${item}`,attrs:{"src":`/insegne/${item}.svg`,"alt":`logo ${item}`}})}),_c('v-spacer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }